import {ValidatorFn} from 'features/search/validators';

export const regnrValidator: ValidatorFn = val => {
  return val.match(/^\d{5,6}$|^[a-zA-Z]\d{1,6}$|^[a-zA-Z]{2}\d{4,5}$/)
    ? {valid: true}
    : {valid: false, error: 'invalid'};
};
